import { render, staticRenderFns } from "./ListReminder.vue?vue&type=template&id=1c69cabe&"
import script from "./ListReminder.vue?vue&type=script&lang=js&"
export * from "./ListReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports